import Accordion from 'semantic-ui-react/dist/commonjs/modules/Accordion';
import '@purple/semantic-ui-purple-theme/components/accordion.css';

export default Accordion;
